import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

const Tabs = TabsPrimitive.Root

const TabsList = (props: React.ComponentProps<typeof TabsPrimitive.List>) => (
  <TabsPrimitive.List {...props} />
)
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = (
  props: React.ComponentProps<typeof TabsPrimitive.Trigger>,
) => <TabsPrimitive.Trigger {...props} />
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = (
  props: React.ComponentProps<typeof TabsPrimitive.Content>,
) => <TabsPrimitive.Content {...props} />
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
